import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { Button } from '../../../../../../../../CommonComponents/OPL/Button/Button';
import { useActionsBar } from './useActionsBar';
import { UserType } from '../../EstatePlanningFlow.meta';

interface Props {
  userType: UserType;
  setUserType: (param: UserType) => void;
  onToggleView: () => void;
  isFlowChartSelected: boolean;
}

export const ActionsBar = ({ userType, setUserType, onToggleView, isFlowChartSelected }: Props) => {
  const { options, optionSelected } = useActionsBar(userType);

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Text fontSize="h5" fontWeight={600} mb="4">
        {optionSelected.label}’s Estate Plan Flow
      </Text>

      <Box display="flex" css="grid-gap: 8px;">
        {options && (
          <Box width="250px">
            <Select
              value={optionSelected}
              options={options}
              onChange={opt => {
                if (opt) {
                  setUserType(opt.value);
                }
              }}
            />
          </Box>
        )}

        {!isFlowChartSelected ? (
          <Button leftIcon="fas fa-sitemap" onClick={onToggleView}>
            Chart
          </Button>
        ) : (
          <Button leftIcon="far fa-table" onClick={onToggleView}>
            Table
          </Button>
        )}
      </Box>
    </Box>
  );
};
